import { Box, Heading, Text } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Link } from '~/components/link';
import { SanityImage } from '~/components/sanity-image';

import { getIndustryDisplayText, getKnowledgeAreaDisplayText } from '../data';
import { EnterpriseCenterResource } from '../types';

export function ResourceCard({
  resource,
  imagePriority,
}: {
  resource: EnterpriseCenterResource;
  imagePriority?: boolean;
}) {
  const surTitle = resource.knowledgeAreas
    ? getKnowledgeAreaDisplayText(resource.knowledgeAreas[0])
    : resource.industries
      ? getIndustryDisplayText(resource.industries[0])
      : '';

  return (
    <Card
      borderRadius='4px 24px 4px 24px'
      boxShadow='md'
      display='flex'
      flexDirection='column'
      height='100%'
      overflow='hidden'
    >
      {resource.resourceCenterImage && (
        <SanityImage
          image={resource.resourceCenterImage}
          priority={imagePriority}
          sizes='(min-width: 1280px) 25vw, (min-width: 992px) 33vw, (min-width: 768px) 50vw, 100vw'
          style={{ objectFit: 'cover', width: '100%', height: '164px' }}
        />
      )}

      <Box display='flex' flex={1} flexDirection='column' padding='24px'>
        <Text>{surTitle}</Text>

        <Heading as='h3' marginTop='16px' size='marketing-lg'>
          {resource.title}
        </Heading>

        <Box h='32px' />

        <Box marginTop='auto'>
          <Link href={resource.linkHref} width='fit-content' withArrow>
            {resource.linkText}
          </Link>
        </Box>
      </Box>
    </Card>
  );
}
